module.exports = __webpack_public_path__ + "img/markt-oelsnitz.a89c4a73.jpeg";